import Swal from "sweetalert2";

export const initiatePayment = async (paymentOptions, orderID, setLoading) => {
  try {
    const razorpay = new window.Razorpay({
      ...paymentOptions,
      payment_capture: 1,
      order_id: orderID,
    });
    setLoading(false);

    razorpay.on("payment.failed", (response) => {
      setLoading(false);
      let errorMessage = "Your payment was unsuccessful. Please try again.";

      switch (response.error.code) {
        case "BAD_REQUEST":
          errorMessage =
            "Invalid payment details entered. Please check and try again.";
          break;
        case "NETWORK_ERROR":
          errorMessage =
            "Payment failed due to a network error. Please check your connection.";
          break;
        case "INSUFFICIENT_FUNDS":
          errorMessage =
            "Your account does not have enough funds to complete this payment.";
          break;
        default:
          errorMessage = response.error.description || errorMessage;
          break;
      }

      Swal.fire({
        title: "Payment Failed",
        text: errorMessage,
        icon: "error",
        customClass: {
          confirmButton: "custom-confirm-button",
        },
      });
    });

    razorpay.open();
    setLoading(false);
    return razorpay;
  } catch (error) {
    setLoading(false);
    Swal.fire({
      title: "Error",
      icon: "error",
      html: `Unexpected error: ${error.message}`,
      customClass: {
        confirmButton: "custom-confirm-button",
      },
    });
  }
};
